<template>
	<v-responsive fluid v-resize="resize">
		<v-card min-width="375" rounded="0">
			<v-card-title primary-title>
				<v-row justify="space-between">
					<v-col cols="10">
						<div
							v-if="$vuetify.breakpoint.xs"
							class="primary--text text-overline ml-2"
						>
							Cuentas de {{ tenantInfo ? tenantInfo.name : '' }}
						</div>
						<div
							v-else
							class="
								font-weight-light
								primary--text
								text-h4
								ml-2
								text-capitalize
							"
						>
							Cuentas {{ tenantInfo ? tenantInfo.name : '' }}
						</div>
					</v-col>
					<v-col cols="2" class="d-flex justify-end align-center">
						<Dial v-if="hasSuperAdminPermission || hasAdminPermission" />
					</v-col>
				</v-row>
			</v-card-title>
			<v-divider class="test"></v-divider>
			<v-data-table
				:height="tableHeight"
				:headers="headers.filter(({ show }) => show)"
				:items="tableData"
				:loading="tableLoading"
				:page.sync="page"
				:footer-props="footerProps"
				:server-items-length="totalEntries"
				:options.sync="options"
				:search="search"
				class="px-2"
				hide-default-footer
			>
				<template v-slot:footer="{ props }">
					<v-data-footer
						style="height: 60px; justify-content: flex-end"
						:items-per-page-options="props.itemsPerPageOptions"
						:options.sync="options"
						:pagination.sync="props.pagination"
						show-first-last-page
					>
					</v-data-footer>
				</template>

				<template v-slot:item.nombreCompleto="{ item }">
					{{
						item.nombre == ''
							? item.username
							: item.nombre + ' ' + item.apellidos
					}}
				</template>

				<template v-slot:item.roles_names="{ item }">
					{{ getRolesString(item) }}
				</template>

				<template v-slot:item.estado="{ item }">
					{{ item.estado }}
				</template>

				<template v-slot:item.actions="{ item }">
					<v-row no-gutters>
						<v-col>
							<v-icon v-on:click.stop @click="viewItem(item)">
								mdi-clipboard-account-outline
							</v-icon>
						</v-col>
						<v-col>
							<v-icon v-on:click.stop @click="editItem(item)">
								mdi-pen
							</v-icon>
						</v-col>
						<v-col v-if="hasSuperAdminPermission">
							<v-icon v-on:click.stop="openDeleteDialog(item)">
								mdi-delete
							</v-icon>
						</v-col>
					</v-row>
				</template>
			</v-data-table>
			<ModHeadersTable :headers="headers" />
			<FormCuentaBase />
			<DownloadTemplateAndUpload
				message="subir la plantilla con los comerciales"
				:multiple="false"
				title="Subida de Comerciales"
				templateMutationPath="gerencia/download_template_from_json"
				templatePath="commercialTemplate.json"
				submitMutationPath="gerencia/importFiles"
				submitPath="import_comerciales_xlsx"
				@submitted="submittedXLSX($event)"
			/>
			<v-dialog
				v-if="hasAdminPermission"
				v-model="deleteDialog"
				width="unset"
			>
				<v-card width="700">
					<div class="d-flex justify-space-between px-4">
						<h1
							class="
								px-3
								font-weight-light
								black--text
								text-center
							"
						>
							¿Está seguro de que quiere borrar a
							{{ currentItem ? currentItem.username : '' }} ?
						</h1>
						<v-icon size="90" color="orange"> mdi-alert </v-icon>
					</div>
					<div class="pt-4">
						<p
							class="
								px-6
								font-weight-light
								black--text
								text-center
							"
						>
							<v-icon color="red">mdi-delete</v-icon>
							Recuerde proceder con cautela, este cambio podría
							ser irreversible y afectar a la consistencia en los
							datos ya existentes en la base de datos. Consulte
							con los administradores si no está seguro de lo que
							está haciendo.
						</p>
					</div>
					<v-card-actions>
						<v-spacer />
						<v-btn
							depressed
							text
							color="red"
							@click="closeDeleteDialog()"
							>Cerrar</v-btn
						>
						<v-btn
							depressed
							color="error"
							@click="deleteItem(currentItem)"
						>
							Borrar
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</v-card>
		<div id="control-height"></div>
	</v-responsive>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import Dial from './Dial.vue';
import FormCuentaBase from '@/components/RRHH/AccountsView/FormCuenta/FormCuentaBase.vue';
import ModHeadersTable from '@/components/GerenciaTeletrabajo/ComercialesTable/ModHeadersTable.vue';
import DownloadTemplateAndUpload from '@/components/DownloadTemplateAndUpload/DownloadTemplateAndUpload.vue';

export default {
	name: 'AccountsTable',
	components: {
		Dial,
		FormCuentaBase,
		DownloadTemplateAndUpload,
		ModHeadersTable,
	},
	data: () => ({
		firstloaded: true,
		deleteDialog: false,
		currentItem: null,
		fab: false,
		decodedTableData: [],
		headers: [
			{
				text: 'Nombre',
				value: 'nombreCompleto',
				sortable: true,
				show: true,
			},
			{
				text: 'Email',
				value: 'email',
				sortable: true,
				show: true,
			},
			{
				text: 'Rol',
				value: 'roles_names',
				sortable: true,
				show: true,
			},
			{
				text: 'Tipo comercial',
				value: 'tipoComercial',
				sortable: true,
				show: true,
			},
			{
				text: 'Estado',
				value: 'estado',
				sortable: true,
				show: true,
			},
			{
				text: 'Last Login',
				value: 'lastLogin',
				sortable: true,
				show: true,
			},
			{
				text: '',
				value: 'actions',
				sortable: false,
				align: 'end',
				width: '160',
				show: true,
			},
		],
		tableHeight: 300,
		footerProps: {
			itemsPerPageOptions: [0],
		},
		previous: '',
		options: {},
	}),
	methods: {
		submittedXLSX(data) {
			this.$store.dispatch('rrhh/getCuentasTableData');
		},
		editItem(item) {
			this.$store.dispatch('rrhh/openEditarCuentaDialogo', item);
		},
		viewItem(item) {
			this.$store.dispatch('rrhh/openCuentaDialogo', item);
		},
		openDeleteDialog(item) {
			this.deleteDialog = true;
			this.currentItem = item;
		},
		closeDeleteDialog() {
			this.deleteDialog = false;
		},
		deleteItem(item) {
			this.$store.dispatch('rrhh/borrarCuenta', item).then(() => {
				this.closeDeleteDialog();
			});
		},
		resize() {
			this.tableHeight =
				document.getElementById('control-height').clientHeight -
				// 50 -
				40 -
				70 -
				32 -
				8 -
				16 -
				15;
		},
		getRolesString(comercial) {
			return this.$store.state.general.rolesDecode[comercial.rol.id];
		},
		...mapActions('rrhh', {
			getTableData: 'getCuentasTableData',
		}),
	},
	mounted() {},
	watch: {
		options: {
			immediate: false,
			handler() {
				let page = this.options.page;
				setTimeout(() => {
					if (
						this.options.page == page &&
						!this.firstloaded &&
						!this.tableLoading
					) {
						this.$store.dispatch(
							'rrhh/updateCuentasTableParams',
							this.options
						);
						this.getTableData();
					}
				}, 200);
			},
			// Permite que el handler se ejecute cuando cambie cualquiera de los campos de options
			deep: true,
		},
		search() {
			let text = this.search;
			// Evitar sobre cargas a la API, solo hace la peticion cuando dejas de escribir
			setTimeout(() => {
				if (text == this.search) {
					this.options.page = 1;
					this.$store.dispatch('rrhh/updateCuentasTableParams', {
						search: this.search,
					});
					this.getTableData();
				}
			}, 300);
		},
		tableHeight() {
			this.footerProps.itemsPerPageOptions[0] = Math.floor(
				this.tableHeight / 48 - 1
			);
			this.options.itemsPerPage = this.footerProps.itemsPerPageOptions[0];
			this.firstloaded = false;
		},
		totalEntries() {
			if (this.totalEntries <= this.footerProps.itemsPerPageOptions[0]) {
				//  this.options.page = 1
			}
		},
	},
	computed: {
		page: {
			get() {
				return this.$store.state.rrhh.cuentasTable.page;
			},
			set(val) {
				this.$store.commit('rrhh/cuentasTablePage', val);
			},
		},
		tenantInfo() {
			return JSON.parse(localStorage.getItem('tenantInfo'));
		},
		...mapState('rrhh', {
			tableData: (state) => state.cuentasTable.cuentas,
			totalEntries: (state) => state.cuentasTable.totalEntries,
			tableLoading: (state) => state.cuentasTable.isLoading,
		}),
		...mapState('util', {
			search: (state) => state.navBarSearchField,
		}),
		...mapGetters('login', {
			hasAdminPermission: 'hasAdminPermission',
			hasSuperAdminPermission: 'hasSuperAdminPermission',
		}),
	},
};
</script>

<style>
#control-height {
	height: 100vh;
	width: 0;
	position: absolute;
}
#center {
	height: 100%;
	width: 100%;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	padding: 0;
}
</style>